import { useState, useRef } from "react";
import { StandardButton } from "../atoms/buttons";

export default function CollapsibleText({ text, maxLength = 100, extra }) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const fullText = (
    <>
      {text}
      {extra && (
        <>
          <br />
          <br />
          {extra}
        </>
      )}
    </>
  );

  const displayText =
    isLong && !expanded ? text.slice(0, maxLength) + "..." : fullText;  

  return (
  <div
    ref={contentRef}
    style={{ width: "auto", maxHeight: "10rem", overflowY: "auto" }}
    className={`collapsible ${expanded ? "expanded" : "collapsed"}`}
  >
    <div className="bottom-text-subtitle" style={{ display: "inline-flex", alignItems: "center", gap: "0.25rem" }}>
      <span onClick={() => setExpanded(!expanded)}>{displayText}</span>
    </div>
  </div>

  );
}
